import { map } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators as Val,
} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ProviderListService } from 'src/app/dashboard/admin/report/services/gate-services/provider-list.service';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import { Validators } from 'src/app/shared/validators';
import { BinProviderGetByMerchantIdService } from '../services/bin-provider-getByMerchantId.service';
import { BinProviderUpdateService } from '../services/bin-provider-update.service';
import { PinManagerData } from '../types';
import { BinMerchantProvidersDeleteService } from '../services/bin-merchantProvider-delete.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-manage-bin-provider',
  templateUrl: './manage-bin-provider.component.html',
  styleUrls: ['./manage-bin-provider.component.scss'],
})
export class ManageBinProviderComponent implements OnInit {
  cashProviders: object[] = [];
  migsProviders: object[] = [];
  mpgsProviders: object[] = [];
  paymentMethodsBackup: object[] = [];
  paymentMethods;
  manageBinProviderForm!: FormGroup;
  success = false;
  selectedPaymentOptions = [];
  OnlyNumPattern = /^\d+$/;
  editMode = false;
  merchantId: any;
  providers: { id: number; name: string }[] = [];
  merchants: { id: number; name: string }[] = [];
  binManagerData: PinManagerData | null;
  constructor(
    private translate: TranslateService,
    public formValidator: FormValidatorService,
    private getBinProviderByMerchantId: BinProviderGetByMerchantIdService,
    private updateBinProvider: BinProviderUpdateService,
    private snackBar: MatSnackBar,
    private router: Router,
    private fb: FormBuilder,
    private ProviderList: ProviderListService,
    private binMerchantProvidersDeleteService: BinMerchantProvidersDeleteService
  ) {
    const state = this.router.getCurrentNavigation()?.extras
      .state as PinManagerData | null;
    this.binManagerData = state;
  }
  binProivderLink = {
    id: {
      fieldName: 'id',
      defaultValue: null,
      validators: [],
    },
    bin: {
      fieldName: 'bin',
      defaultValue: null,
      validators: [
        {
          validatorFn: Validators.required,
          message: this.translate.instant('FORMS.VALIDATION.REQUIRED', {
            field: 'bin numbers',
          }),
        },
        {
          validatorFn: Validators.minLength(6),
          message: this.translate.instant('FORMS.VALIDATION.MINIMUM_LENGTH', {
            field: 'bin numbers',
            value: 6,
          }),
        },
        {
          validatorFn: Validators.maxLength(6),
          message: this.translate.instant('FORMS.VALIDATION.MAXIMUM_LENGTH', {
            field: 'bin numbers',
            value: 6,
          }),
        },
        {
          validatorFn: Validators.pattern(this.OnlyNumPattern),
          message: 'must be only numbers',
        },
      ],
    },
  };

  get reportHeader() {
    const startWord = this.editMode ? 'Edit' : 'Create';
    const msg =
      startWord +
      ' ' +
      this.binManagerData.merchant.name +
      ' ' +
      'bins for' +
      ' ' +
      this.binManagerData.provider.name +
      ' ' +
      'provider';
    return msg;
  }

  async ngOnInit() {
    try {
      if (!this.binManagerData.merchant.id && !this.binManagerData.merchant.id)
        throw new Error('merchantId or providerId is missing.');

      this.editMode = true;
      this.getBinProviderByMerchantId.setParams({
        merchantId: this.binManagerData.merchant.id,
        providerId: this.binManagerData.provider.id,
      });
      const response = await this.getBinProviderByMerchantId.make();

      this.initForm();
      for (const res of response) {
        this.addBinProviderGroup(res.id, res.bin);
      }
    } catch (err) {
      this.router.navigate(['admin/bin-providers']);
    }
  }
  get binProviderLinks() {
    return this.manageBinProviderForm.get('bin_providerLinks') as FormArray;
  }
  initForm() {
    this.manageBinProviderForm = this.fb.group({
      bin_providerLinks: this.fb.array([])
    });
    if (this.binProviderLinks.length == 0 && !this.editMode) {
      this.addBinProviderGroup();
    }
  }

  addBinProviderGroup(id: number = null, bin: string = null) {
    if (this.binProviderLinks.valid) {
      let newFormObj = { ...this.binProivderLink };
      if (id && bin) {
        newFormObj.bin.defaultValue = bin;
        newFormObj.id.defaultValue = id;
      } else {
        newFormObj.bin.defaultValue = null;
        newFormObj.id.defaultValue = null;
      }
      this.binProviderLinks.push(
        this.formValidator.createForm(Object.values(newFormObj))
      );
    }
  }

 async removeItems(i: number) {
    try{
      const formValue = this.binProviderLinks.get(`${i}`).value;
      if(!formValue.id)  return this.binProviderLinks.removeAt(i);

      Swal.fire({
        title: 'Are you sure you want to delete this Merchant Provider bin data?',
        text: '',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      }).then(async (result) => {
        if (result.value) {
          this.binMerchantProvidersDeleteService.setParams({
            merchantId: this.binManagerData.merchant.id,
            providerId: this.binManagerData.provider.id,
            providerBinId: formValue.id
          })
          let responseData = await this.binMerchantProvidersDeleteService.make();
          if (responseData.success) {
            this.binProviderLinks.removeAt(i);
          }
        }
      });
    }catch(error){
    }
  }

  async getProviders() {
    this.ProviderList.setParams({
      date: '',
      search: '',
      pageSize: 1000,
      pageNumber: 1,
      columns: ['name'],
    });
    let responsData = await this.ProviderList.make();
    this.providers = responsData.providers;
  }

  convertbinProviderLinksControls(index: number, name: string) {
    return this.binProviderLinks.controls[index].get(name) as FormControl;
  }
  async onSubmit() {
    try {
      const bin_providerLinks = this.manageBinProviderForm.get("bin_providerLinks");
      const binGroups = (bin_providerLinks["controls"] as unknown as FormGroup[]);

      const modifiedGroupsValues = [];
      binGroups.forEach((group: FormGroup) => {
        if (!group.pristine && group.valid)
        modifiedGroupsValues.push({ bin: group.value.bin, providerBinId: group.value.id });
      })

      if(!modifiedGroupsValues.length) return;

      this.updateBinProvider.setParams({
        merchantId: this.binManagerData.merchant.id,
        providerId: this.binManagerData.provider.id,
        data: modifiedGroupsValues
        });
        const res = await this.updateBinProvider.make();

        if (res.success) {
          this.success = true;
          this.snackBar.open(`Bill service Edited Successfully!`, '', {
            duration: 3000,
          });
        }

        modifiedGroupsValues.length = 0;
    } catch (err) {
      this.manageBinProviderForm.setErrors({ invalid: true });
      const e = err.faultyRequest?.error;
      if (e.fieldErrors) {
        for (const error of e.fieldErrors) {
          for (const ctrl of this.binProviderLinks.controls) {
            const fieldControl = ctrl.get(error.field);
            if (fieldControl.value === error.value) {
              if (!fieldControl.errors) {
                fieldControl.setErrors({ invalid: error.message });
              }
            }
          }
        }
      }
    }
  }
  convertControls(name: string) {
    return this.manageBinProviderForm.get(name) as FormControl;
  }
}
interface bin_ProviderFormValue {
  bin_providerLinks: { bin: string; providerId: string }[];
  merchantId: string;
}
